import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

/**
 * A small label. The tone carries meaning, so pick it from what the label
 * says, not to decorate: neutral for ordinary facts, warning (amber) only for
 * something that needs the team, danger for failure.
 */
export const badgeVariants = cva(
  'inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium',
  {
    variants: {
      variant: {
        default: 'bg-muted text-muted-foreground',
        outline: 'border border-border-strong text-muted-foreground',
        success: 'bg-success-muted text-success',
        info: 'bg-info-muted text-info',
        warning: 'bg-warning-muted text-warning',
        danger: 'bg-danger-muted text-danger',
        selected: 'bg-selected text-selected-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.ComponentPropsWithoutRef<'span'>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
